import type { SxProps, Theme } from "@mui/material";
import { MenuItem, TextField } from "@mui/material";
import { useStandsLookup } from "../hooks/usePassIds";

interface StandSelectorProps {
	value: number | null;
	onChange: (value: number | null) => void;
	label?: string;
	fullWidth?: boolean;
	size?: "small" | "medium";
	required?: boolean;
	disabled?: boolean;
	includeAll?: boolean;
	error?: boolean;
	sx?: SxProps<Theme>;
}

export const StandSelector = ({
	value,
	onChange,
	label = "Stand",
	fullWidth = false,
	size = "small",
	required = false,
	disabled = false,
	includeAll = false,
	error = false,
	sx,
}: StandSelectorProps) => {
	const { data: stands = [], isLoading } = useStandsLookup();

	return (
		<TextField
			select
			label={label}
			value={value ?? ""}
			onChange={(e) =>
				onChange(e.target.value === "" ? null : Number(e.target.value))
			}
			size={size}
			fullWidth={fullWidth}
			required={required}
			disabled={disabled || isLoading}
			error={error}
			sx={{ minWidth: 120, ...sx } as SxProps<Theme>}
		>
			{(includeAll || !required) && (
				<MenuItem value="">
					<em>All</em>
				</MenuItem>
			)}
			{stands.map((stand) => (
				<MenuItem key={stand.Id} value={stand.Id}>
					{stand.Name}
				</MenuItem>
			))}
		</TextField>
	);
};
